import React,{useState, useEffect} from "react";
import { API } from '../../../services/api';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { HeaderAdmin } from "../../components/HeaderAdmin/HeaderAdmin";
import { LateralMenu } from "../../components/LateralMenu/LateralMenu";
import ImgLoading from '../../../assets/cargacaleta.gif';
import "./CommentRejectUser.scss";

export function CommentRejectUserPage() {
  /**
   * Vista para dejar el motivo de rechazo de un usuario
   * Se pasa por la url el userId
   * Se envían el comentario de rechazo de un usuario al servidor
   */
  const [userId, setUserId] = useState('');
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const history = useHistory();

  const protectedRoute = ()=>{
    const sessionToken = localStorage.getItem('sessionToken');
    if(!sessionToken){
      history.push('/staff-login')
    }
  }

  const rejectUser = async()=>{
    if(window.confirm('Registrar comentario?')){
      setLoading(true);
      /**
       * Actualizar el estado de un usuario
       * Se hace el llamado del servicio /users/update-user-approval-state
       */
      await API.putUserApprovalSatate({
        userId,
        approvalState: 'REJECTED',
        approvalStateDescription: comment
      });
      setLoading(false);
      history.push('user-requests')      
    }
    
  }

  useEffect(()=>{
    protectedRoute();
    const queryParams = new URLSearchParams(location.search);
    setUserId(queryParams.get('userId'))
  },[]);

  if(loading){
    return <>
      <HeaderAdmin />
      <LateralMenu />
      <main className='content-img'>
        <img className='img-loading' src={ImgLoading} alt="" />
      </main>
    </>
  }

  return (
    <>
      <HeaderAdmin />
      <LateralMenu />
      <main className="content">
        <h2>Ingrese un motivo</h2>
        <Link className="button-back" to={{pathname:`user-requests`}}>Volver a la lista de solicitudes</Link>
        <div className="card">
          <p>Comentario</p>
          <input type="text" onChange={(e) => setComment(e.target.value)}/>
          <button 
          disabled={loading}
          className="button-register" 
          onClick={()=>rejectUser()}>Registrar</button>
        </div>
      </main>
    </>
  )
}
